import { logger } from '@/shared/logging';

const setupLogger = logger('setup');

export function setupLog(name:string) {
    return setupLogger.child(name, true);
}
